import { isPromise } from "./_internal/utils.js";
function tap(f, v) {
    if (v === undefined) {
        return (v) => tap(f, v);
    }
    const res = isPromise(v) ? v.then(f) : f(v);
    if (isPromise(res)) {
        return res.then(() => v);
    }
    return v;
}
export default tap;
//# sourceMappingURL=tap.js.map